<template>
  <div class="jy-detail" v-if="type!==''">
    <nav-bar @backClick="handleBack" :navbartitle="navTitle"></nav-bar>

    <!-- 顶部轮播图 -->
    <div class="bannerBox">
      <swiper :options="swiperOption" ref="mySwiper" @slideChangeTransitionStart="slideEnd">
        <template v-for="(banner,bannerIndex) in list[type].items">
          <swiper-slide
            class="bannerItem"
            :class="{'big':activeIndex==bannerIndex,'small':activeIndex!=bannerIndex}"
            :key="bannerIndex"
          >
            <img
              class="banner"
              :class="{'big':activeIndex==bannerIndex,'small':activeIndex!=bannerIndex}"
              :src="'/static/images/strategy/'+banner.theme+ (activeIndex!=bannerIndex?'_small.png':'_big.png')"
            >
            <div class="title">{{banner.title}}</div>
            <div class="subtitle" v-html="banner.subtitle"></div>
          </swiper-slide>
        </template>
      </swiper>
    </div>

    <div v-for="(item,index) in list[type].items" :key="index">
      <!-- 使用场景 -->
      <div class="sceneBox dividerBox" v-show="activeIndex==index">
        <div class="divider">
          <div class="point" :class="[item.theme]"></div>
          <span class="content">使用场景/用途</span>
        </div>
        <div class="sceneContent">{{item.sence}}</div>
      </div>

      <!-- 操作步骤 -->
      <div class="stepBox dividerBox" v-show="activeIndex==index">
        <div class="divider">
          <div class="point" :class="[item.theme]"></div>
          <span class="content">操作步骤</span>
        </div>
        <div class="stepItem" v-for="(step,setpIndex) in item.steps" :key="setpIndex">
          <div class="item" v-for="(s,sIndex) in step.items" :key="sIndex">
            <div class="group">{{s.group}}</div>
            <div class="title">{{s.title}}</div>
            <div class="content">{{s.content}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from "@/components/navBar";
export default {
  data() {
    return {
      type: "extension", // 传入的类型
      navTitle: "", // 顶部导航栏
      activeIndex: 0,
      swiperOption: {
        width: 178
      },
      list: {
        extension: {
          title: "拓客",
          items: [
            {
              theme: "orange",
              title: "异业推荐",
              subtitle: "你的给我，我的给你<br/>我的还是我的，你的也是我的",
              sence:
                "当有顾客在您的店里消费，您可以根据用户的需求情况把周边异业店铺的优惠券推荐给顾客。用户领取优惠券消费后，您的店铺可获得每笔交易的20%的提成（店主5%，推荐人15%。推荐人可以是店铺员工或者店主）",
              steps: [
                {
                  group: "",
                  items: [
                    {
                      title: "1. 匹配店铺",
                      content:
                        "点击主导航“拓客”进入，默认为异业拓客操作界面。点击“匹配店铺”进入条件设定页面，根据客户的需求选择好条件，进行“快速匹配”店铺，系统根据您设定的需求条件推荐3家以内合适的周边店铺。"
                    },
                    {
                      title: "2. 分享优惠券",
                      content:
                        "选择匹配的店铺进入店铺详情，点击页面底部的分享按钮进入分享界面。用户可当面使用微信扫码领取优惠券，您也可以将优惠券通过微信发送给该顾客。"
                    },
                    {
                      title: "3. 顾客领取使用优惠券",
                      content:
                        "顾客通过微信端领取优惠券后，根据自己的需求前往被推荐的店铺消费。消费后向店铺工作人员展示优惠券，并让该店铺人员使用剑琅联盟“扫码验券”核销后，您的推荐正式达成，坐等佣金结算。"
                    }
                  ]
                }
              ]
            },
            {
              theme: "red",
              title: "老带新",
              subtitle: "好东西就该分享给朋友",
              sence:
                "某顾客A在您店里完成消费，您可以让顾客A把本店的优惠活动分享给他的好友。顾客A的好友领取优惠项目并成功消费后，顾客A可获得消费金额20%的积分（1积分=1元）。顾客A所获得的积分可在您店里兑换好礼，比如再次来店消费时可使用积分抵扣（兑换由您自己规定）。",
              steps: [
                {
                  items: [
                    {
                      title: "",
                      group: "店铺人员引导顾客老带新 ",
                      content:
                        "从底部导航进入“拓客”页面，选择“老带新”标签页，通过以下方式达到引导老带新拓客："
                    },
                    {
                      title: "1. 面对面扫码 ",
                      content:
                        "将二维码向本店老顾客展示，顾客使用微信扫码后，立即查看您店铺的优惠项目，点击“分享给微信好友”即可将优惠项目推荐给ta的好友。"
                    },
                    {
                      title: "2.推送给本店老客 ",
                      content:
                        "点击“推送给本店顾客”进入本店老顾客选择页面，选择顾客后确认发送，该顾客即可通过剑琅联盟-顾客版查看您推送的店铺优惠项目，点击“分享给微信好友”即可将优惠项目推荐给ta的好友。"
                    },
                    {
                      title: "3.分享到微信好友 ",
                      content:
                        "点击“分享到微信好友”进入微信好友选择页面，选择后确认发送，好友（老顾客）即可查看您分享的店铺优惠项目，点击“分享给微信好友”即可将优惠项目推荐给ta的好友。"
                    },
                    {
                      group: "顾客主动老带新",
                      title: "",
                      content:
                        "使用剑琅联盟-顾客版的顾客再您的店铺消费后，可在店铺详情中查看你店铺最新发布的优惠项目，点击“打包分享”即可将优惠项目分享给微信好友。"
                    }
                  ]
                }
              ]
            }
          ]
        },
        shop: {
          title: "店铺维护",
          items: [
            // {
            //   theme: "orange",
            //   title: "店铺认证",
            //   subtitle: "完成认证，随时拓客",
            //   sence:
            //     "登录App后您的店铺处于未认证状态，此状态下无法使用拓客和店铺码功能，也无法参与剑琅联盟的任何活动。您需按照要求提交相关认证资料，完成认证后即可使用相关功能。",
            //   steps: [
            //     {
            //       items: [
            //         {
            //           title: "",
            //           content:
            //             "登录App后，在首页点击店铺名称旁的“未认证”标识进入认证资料提交页。"
            //         },
            //         {
            //           title: "",
            //           group: "根据要求您需提交以下资料：",
            //           content:
            //             "1.店铺门头照：请上传一张店铺门头照，照片中的店铺名称需与注册时填写的店铺名称一致"
            //         },
            //         {
            //           title: "",
            //           content:
            //             "2.营业执照或店主证明照：请尽量上传店铺的营业执照。如果没有，请店主拍摄一张手持“我是店主”字样卡纸的照片并上传"
            //         }
            //       ]
            //     }
            //   ]
            // },
            {
              theme: "red",
              title: "店铺信息",
              subtitle: "信息越完善，拓客机会越多",
              sence:
                "店主登录App后，可以完善或修改店铺信息，将自己的店铺更好的展现给异业店铺和顾客，获得更多的获客机会。",
              steps: [
                {
                  items: [
                    {
                      title: "",
                      group: " ",
                      content:
                        "登录App后，在首页点击“店铺信息”进入店铺信息编辑页面，根据要求真实填写。"
                    }
                  ]
                }
              ]
            },
            {
              theme: "blue",
              title: "店铺秀",
              subtitle: "一看店铺秀，便知有没有",
              sence:
                "店主可将本店的多角度环境照、员工作品上传至店铺，以供异业商户查看，从而消除异业店铺的推荐顾虑，并让顾客信任您店铺的技术实力，客大大提高获客转化率。",
              steps: [
                {
                  items: [
                    {
                      title: "",
                      group: "",
                      content:
                        "登录App后，在首页点击“店铺秀”进入上传页面，可随时上传和更新您店铺的照片，最多上传9张。"
                    }
                  ]
                }
              ]
            }
          ]
        },
        create: {
          title: "创建优惠活动",
          items: [
            {
              theme: "orange",
              title: "优惠活动",
              subtitle: "一口价项目，拓客杀手锏",
              sence:
                "将优惠项目发布至店铺（同时最多上架3个优惠项目）展示，异业店铺可帮您向ta的顾客推荐，您店铺的老客也可以方便的向朋友推荐，让您的拓客渠道变多，成功率更高。",
              steps: [
                {
                  items: [
                    {
                      title: "",
                      content:
                        "店主登录App，进入首页点击“本店优惠活动”进入活动管理页面，点击页面右上角的“新建活动”开始创建优惠活动。"
                    },
                    {
                      title: "",
                      group: "",
                      content: "店员身份不可以创建优惠活动。"
                    }
                  ]
                }
              ]
            }
          ]
        },
        scancode: {
          title: "扫码验券",
          items: [
            {
              theme: "orange",
              title: "扫码验券",
              subtitle: "扫码扫码，一辨真假",
              sence:
                "领到您店铺优惠券的顾客来店消费后，向您展示优惠码，使用“扫码验券”进行优惠券验证和核销。",
              steps: [
                {
                  items: [
                    {
                      title: "",
                      content:
                        "店主登录App，进入首页点击“扫码验券”进入二维码扫描界面，将手机摄像头对准顾客展示的优惠码进行识别验证，验证有效完成核销。"
                    },
                    {
                      title: "",
                      group: "",
                      content:
                        "顾客张优惠券核销后，状态变成已使用，不能再使用。"
                    }
                  ]
                }
              ]
            }
          ]
        },
        bill: {
          title: "积分结账",
          items: [
            {
              theme: "orange",
              title: "积分结账",
              subtitle: "好礼给出去，积分需收回",
              sence:
                "老客帮您的店铺完成了老带新的推荐，即可获得新客消费金额20%的积分（1积分=1元）。老客揣著积分来店，享受积分兑礼，您需对将积分结账收回。",
              steps: [
                {
                  items: [
                    {
                      title: "",
                      content:
                        "登录App后，进入首页点击“积分结账”进入积分结账页面，选择顾客姓名，填写积分兑礼所需的积分数，点击“积分结账”后迅速完成积分核销。"
                    },
                    {
                      title: "",
                      group: "",
                      content:
                        "此功能可对员工设置权限，店主在创建员工时或进入员工管理对员工使用权限进行授权或取消授权操作。"
                    }
                  ]
                }
              ]
            }
          ]
        },
        pay: {
          title: "获客费用支付",
          items: [
            {
              theme: "orange",
              title: "获客费用支付",
              subtitle: "异业推荐很辛苦，给ta佣金补一补",
              sence:
                "异业帮您推荐并成功拓客，根据平台协议约定，需向推荐方和平台支付获客费用。每月1号生成上月的获客费用账单，每月8号为上月账单的最后付款日。账单逾期1天未支付，诚信度降低1星，补缴所有逾期费用后诚信度恢复至5星。",
              steps: [
                {
                  items: [
                    {
                      title: "",
                      content:
                        "登录App后，进入首页点击“获客费用支付”进入账单明细查看页面，应付费用和明细一目了然，点击“支付”进入支付并完成付款操作。"
                    }
                  ]
                }
              ]
            }
          ]
        },
        withdraw: {
          title: "推荐费用提现",
          items: [
            {
              theme: "orange",
              title: "推荐费用提现",
              subtitle: "推荐越多，收益越多",
              sence:
                "通过推荐帮异业成功拓客，并且获客店也支付了获客费用，您即可获得每笔消费金额20%的推荐收益（店主5%，推荐人15%），到账后可随时提现到您绑定的微信钱包账户。",
              steps: [
                {
                  items: [
                    {
                      title: "1.绑定微信钱包 ",
                      content:
                        "提现操作前需先完成微信钱包账户绑定。进入首页点击右上角“设置”图标进入设置页面，点击“微信绑定”进入微信钱包账户绑定流程，完成操作。"
                    },
                    {
                      title: "2.佣金提现 ",
                      group: "",
                      content:
                        "登录App，进入首页点击“佣金提现”进入推荐收益明细页，当可提现金额大于0时，点击“提现”进入提现流程，完成操作。"
                    },
                    {
                      content:
                        "提现到账大概需要1~2个工作日，资金转入您绑定的微信钱包。"
                    }
                  ]
                }
              ]
            }
          ]
        },
        set: {
          title: "个人秀",
          items: [
            {
              theme: "orange",
              title: "个人秀",
              subtitle: "作品是检验活好的唯一标准",
              sence:
                "店主/店员可将自己的作品上传至店铺展示，异业店铺和顾客通过对作品的了解判断您店铺的技术实力。",
              steps: [
                {
                  items: [
                    {
                      title: "",
                      content:
                        "进入首页点击“个人秀”进入作品上传页面，点击“上传作品”进行图片上传流程（最多上传9张）。"
                    }
                  ]
                }
              ]
            }
          ]
        },
        staff: {
          title: "员工管理",
          items: [
            {
              theme: "orange",
              title: "员工管理",
              subtitle: "一个店主 多个帮手",
              sence:
                "店主创建店内各员工账号，店员直接登录使用（店员登录功能仅开放部分）。",
              steps: [
                {
                  items: [
                    {
                      title: "",
                      content:
                        "进入首页点击“员工管理”进入员工管理页面，点击页面下方的“创建员工”进入新员工账号创建，完成操作。"
                    },
                    {
                      title: "",
                      group: "",
                      content:
                        "员工手机号作为登录账号，员工可使用手机号进行验证码登录。"
                    }
                  ]
                }
              ]
            }
          ]
        },
        icon: {
          title: "积分兑礼设置",
          items: [
            {
              theme: "orange",
              title: "积分兑礼",
              subtitle: "老客帮您推，好礼诚心给",
              sence:
                "针对老客帮您店铺带来新客所获得的店铺积分，根据平台协议约定您需要通过对应价值的好礼进行回馈。好礼可以是实物礼品，也可以是您店铺的项目。",
              steps: [
                {
                  items: [
                    {
                      title: "",
                      content:
                        "进入首页点击“会员积分/兑礼”进入积分兑礼页，选择“积分兑礼”标签页进入积分项目设置页面，点击右上角的“新建”创建积分兑礼项目。"
                    },
                    {
                      title: "",
                      group: "",
                      content:
                        "如果想修改或删除积分项目，点击“修改”或“删除” 即可。"
                    },
                    {
                      content:
                        "设置完的积分兑礼项目会展示在您的店铺详情中，异业店铺和顾客可查看。"
                    }
                  ]
                }
              ]
            }
          ]
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    this.type = this.$route.params.type;
    this.navTitle = this.list[this.type].title;
  },
  methods: {
    slideEnd(e) {
      this.activeIndex = this.swiper.activeIndex;
    },
    handleBack(){
      this.$router.go(-1)
    }
  },
  components: {
    NavBar
  }
};
</script>
<style lang="scss" scoped>
.swiper-slide-prev {
  width: 178px;
  right: -46px;
  margin-top: 12px;
}
.swiper-slide-active {
  width: 250px !important;
  margin-left: 76px;
  // height: 125px;
}
.swiper-slide-next {
  margin-top: 12px;
  width: 178px;
  left: 20px;
}
.jy-detail {
  overflow-x: hidden;
  .bannerBox {
    margin: 25px 0;
    .bannerItem {
      text-align: center;
      &.big {
        height: 125px;
        line-height: 12px;
      }
      &.small {
        width: 178px;
        height: 102px;
        line-height: 102px;
      }
      position: relative;
      .banner {
        &.big {
          width: 250px;
          height: 125px;
        }
        &.small {
          width: 178px;
          height: 102px;
        }
      }
      .title {
        position: absolute;
        top: 20px;
        left: 26px;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        font-family: PingFangSC-Semibold;
        color: rgba(255, 255, 255, 1);
        line-height: 20px;
      }
      .subtitle {
        position: absolute;
        top: 52px;
        left: 26px;
        text-align: left;
        font-family: PingFangSC-Regular;
        width: 158px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 16px;
      }
    }
  }
  .dividerBox {
    padding: 0 17px;
    .divider {
      height: 16px;
      line-height: 16px;
      margin-bottom: 16px;
      .point {
        display: inline-block;
        margin: 3px 0;
        width: 10px;
        height: 10px;
        border-radius: 6px;
        &.orange {
          background: rgba(255, 159, 77, 1);
        }
        &.red {
          background: rgba(255, 75, 57, 1);
        }
        &.blue {
          background: rgba(110, 181, 252, 1);
        }
      }
      .content {
        margin-left: 15px;
        height: 16px;
        font-size: 16px;
        font-family: PingFangSC-Semibold;
        font-weight: bold;
        color: rgba(66, 66, 66, 1);
        line-height: 16px;
        vertical-align: top;
      }
    }
  }
  .sceneBox {
    .sceneContent {
      font-size: 15px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 25px;
    }
  }
  .stepBox {
    margin-top: 40px;
    .stepItem {
      .item {
        font-size: 15px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 25px;
        margin-bottom: 40px;
        .group {
          color: rgba(66, 66, 66, 1);
        }
        .title {
        }
        .content {
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/strategy/StrategyDetail.vue